import { createReducer, on } from '@ngrx/store';

import { RestUnitRenewalTargetModel } from '@shared/interfaces/renevals.interface';
import { RestThresholdSection } from '@shared/interfaces/rest-threshold-section';

import {
  getRenewalTargetList,
  getRenewalTargetListFailure,
  getRenewalTargetListSuccess,
  loadAllThresholds,
  loadAllThresholdsFailed,
  loadAllThresholdsSuccess,
  loadThresholdsProperty,
  loadThresholdsPropertyFailed,
  loadThresholdsPropertySuccess,
  loadThresholdsTask,
  loadThresholdsTaskFailed,
  loadThresholdsTaskSuccess,
  setThresholdsConfig,
  setThresholdsConfigFailed,
  setThresholdsConfigSuccess,
  updateRenewalTarget,
  updateRenewalTargetFailure,
  updateRenewalTargetSuccess,
} from './management.actions';

export const managementFeatureKey = 'management';

export interface ManagementState {
  thresholdSectionLoading: boolean;
  thresholdSections: RestThresholdSection[];
  thresholdSectionPropertyLoading: boolean;
  thresholdSectionProperty: RestThresholdSection[];
  thresholdSectionTaskLoading: boolean;
  thresholdSectionTask: RestThresholdSection[];
  thresholdUpdateLoading: boolean;
  renewalTargetList: RestUnitRenewalTargetModel[];
  renewalTargetListLoading: boolean;
  updateRenewalTargetModelLoading: boolean;
}

export const initialState: ManagementState = {
  thresholdSectionLoading: false,
  thresholdSections: [],
  thresholdSectionPropertyLoading: false,
  thresholdSectionProperty: [],
  thresholdSectionTaskLoading: false,
  thresholdSectionTask: [],
  thresholdUpdateLoading: false,
  renewalTargetList: [],
  renewalTargetListLoading: false,
  updateRenewalTargetModelLoading: false,
};

export const reducer = createReducer(
  initialState,
  /**
   * Threshold sections
   */
  on(loadAllThresholds, (state, action) => ({ ...state, thresholdSectionLoading: true })),
  on(loadAllThresholdsSuccess, (state, action) => ({
    ...state,
    thresholdSectionLoading: false,
    thresholdSections: action.thresholdSections,
  })),
  on(loadAllThresholdsFailed, (state, action) => ({ ...state, thresholdSectionLoading: false, thresholdSections: [] })),

  /**
   * Thresholds Property
   */
  on(loadThresholdsProperty, (state, action) => ({ ...state, thresholdSectionPropertyLoading: true })),
  on(loadThresholdsPropertySuccess, (state, action) => ({
    ...state,
    thresholdSectionPropertyLoading: false,
    thresholdSectionProperty: action.thresholdProperty,
  })),
  on(loadThresholdsPropertyFailed, (state, action) => ({
    ...state,
    thresholdSectionPropertyLoading: false,
    thresholdSectionProperty: null,
  })),

  /**
   * Thresholds task
   */
  on(loadThresholdsTask, (state, action) => ({ ...state, thresholdSectionTaskLoading: true })),
  on(loadThresholdsTaskSuccess, (state, action) => ({
    ...state,
    thresholdSectionTaskLoading: false,
    thresholdSectionTask: action.thresholdTask,
  })),
  on(loadThresholdsTaskFailed, (state, action) => ({
    ...state,
    thresholdSectionTaskLoading: false,
    thresholdSectionTask: [],
  })),

  /**
   * Threshold update
   */
  on(setThresholdsConfig, (state, action) => ({ ...state, thresholdUpdateLoading: true })),
  on(setThresholdsConfigSuccess, (state, action) => ({
    ...state,
    thresholdUpdateLoading: false,
  })),
  on(setThresholdsConfigFailed, (state, action) => ({
    ...state,
    thresholdUpdateLoading: false,
  })),

  /**
   * get renewal target list
   */
  on(getRenewalTargetList, (state, action) => ({ ...state, renewalTargetListLoading: true })),
  on(getRenewalTargetListSuccess, (state, action) => ({
    ...state,
    renewalTargetList: action.renewalTargetList,
    renewalTargetListLoading: false,
  })),
  on(getRenewalTargetListFailure, (state, action) => ({
    ...state,
    renewalTargetList: [],
    renewalTargetListLoading: false,
  })),

  /**
   * update renewal target
   */
  on(updateRenewalTarget, (state, action) => ({ ...state, updateRenewalTargetModelLoading: true })),
  on(updateRenewalTargetSuccess, (state, action) => ({
    ...state,
    updateRenewalTargetModelLoading: false,
  })),
  on(updateRenewalTargetFailure, (state, action) => ({
    ...state,
    updateRenewalTargetModelLoading: false,
  }))
);
